import { render, staticRenderFns } from "./FacultySelectbox.vue?vue&type=template&id=291a2c65"
import script from "./FacultySelectbox.vue?vue&type=script&lang=js"
export * from "./FacultySelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports